<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30"><path fill-rule="evenodd" d="M8 4h19v1H8zm0 7h19v1H8zm0 7h19v1H8zm0 7h19v1H8zM4 5H3v1h3V5H5V2H3v1h1zM3 17.5h2V17H3v-1h3v4H3v-1h2v-.5H3zm0 7.88V26h2v1h1v-3H5v1h-.7l.87-1.72-.9-.45zM6 9H3v1h2v.2l-2 1V13h3v-1H4v-.2l2-1z"/></svg>
</template>
